var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPurchaseOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 3.125H15.625C15.9565 3.125 16.2745 3.2567 16.5089 3.49112C16.7433 3.72554 16.875 4.04348 16.875 4.375V17.5C16.875 17.8315 16.7433 18.1495 16.5089 18.3839C16.2745 18.6183 15.9565 18.75 15.625 18.75H4.375C4.04348 18.75 3.72554 18.6183 3.49112 18.3839C3.2567 18.1495 3.125 17.8315 3.125 17.5V4.375C3.125 4.04348 3.2567 3.72554 3.49112 3.49112C3.72554 3.2567 4.04348 3.125 4.375 3.125H6.25V2.5C6.25 2.16848 6.3817 1.85054 6.61612 1.61612C6.85054 1.3817 7.16848 1.25 7.5 1.25H12.5C12.8315 1.25 13.1495 1.3817 13.3839 1.61612C13.6183 1.85054 13.75 2.16848 13.75 2.5V3.125ZM12.5 2.5H7.5V5H12.5V2.5ZM4.375 17.5H15.625V4.375H13.75V6.25H6.25V4.375H4.375V17.5ZM7.5 8.75H6.25V15H7.5V8.75ZM12.5 11.25H13.75V15H12.5V11.25ZM9.375 12.5H10.625V15H9.375V12.5Z",
    fill: "#E9EEF7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrders);
export default __webpack_public_path__ + "static/media/PurchaseOrders.08cf22995a07d81de3e48e2e3eb9e817.svg";
export { ForwardRef as ReactComponent };